import _ from 'lodash';
import { Field, useForm } from 'react-final-form';
import { DateTimeEntry } from '@/datetime/DateTimeEntry.atom';
import { FormFieldWrapper } from '@/formbuilder/FormFieldWrapper';
import { getFormFieldProps, getValidationFunction } from '@/formbuilder/formbuilder.utilities';
import type moment from 'moment-timezone';
import type { Timezone } from '@/datetime/timezone.service';
import type { ValidatingFormComponent } from '@/formbuilder/formBuilder.types';
import type { TrackCategory } from '@/track/track.constants';

export interface DateTimeEntryIF extends ValidatingFormComponent<moment.Moment> {
  component: 'DateTimeEntryFormComponent';
  hideTimezone?: boolean;
  timezone: Timezone;
  trackCategory?: TrackCategory;
  trackAction?: string;
  trackInformation?: string;
  dateFormat?: string;
}

export const DateTimeEntryFormComponent = (props: DateTimeEntryIF) => {
  const {
    label,
    name,
    testId = 'dateTimeEntry',
    extraClassNames,
    wrapperClassNames,
    hideTimezone,
    timezone,
    customErrorText,
    extendValidation,
    validation,
    trackCategory,
    trackAction,
    trackInformation,
    dateFormat,
  } = props;

  const formState = useForm().getState();
  const showError = _.has(formState.errors, name) && _.has(formState.dirtyFields, name);

  const defaultValidation = (value: moment.Moment) => !value;
  const appliedValidation = getValidationFunction(defaultValidation, extendValidation, validation);

  return (
    <FormFieldWrapper
      wrapperXstyle={props.wrapperXstyle}
      fieldXstyle={[props.xstyle, props.fieldXstyle]}
      labelXstyle={props.labelXstyle}
      testId={testId}
      label={label}
      extraClassNames={extraClassNames}
      wrapperClassNames={wrapperClassNames}
      showError={showError}
      customErrorText={customErrorText}>
      <Field name={name} validate={appliedValidation}>
        {({ input, meta }) => {
          const { value, onChange } = getFormFieldProps(formState, input, meta, props);

          return (
            <DateTimeEntry
              testId={`${testId}Field`}
              extraClassName="specRange specRangeStart width-115"
              datePickerExtraClassNames="sq-text-primary flexRowContainer width-100"
              date={value}
              updateDate={onChange}
              dateFormat={dateFormat}
              timezone={timezone}
              hideTimezone={hideTimezone}
              trackCategory={trackCategory}
              trackAction={trackAction}
              trackInformation={trackInformation}
            />
          );
        }}
      </Field>
    </FormFieldWrapper>
  );
};
